// LemmaParseHeadUtils.js (updated with support for lemma_chs expanded details)
import React, { useState } from 'react';
import { SpeakTextButton,BookAudioPlayer } from './LemmaPlayUtils';
import './LemmaParseHeadUtilstyle.css';
import './CmnBookParseHeadUtilstyle.css';

const CmnBookDisplay = ({ lemmashead, showpinyin,aidtext = '', paracont}) => {
  const [tempShow, setTempShow] = useState(false);
  const [showMore, setShowMore] = useState(false);
  if (!lemmashead) return null;
  let parsed_paracont = {};
  try {
      parsed_paracont = JSON.parse(paracont);
    } catch (error) {
      return <div>Invalid paracont.</div>;
    }
 // Inside your parse_head function...

const handleCopy = (event) => {
  const selection = window.getSelection();
  if (!selection.rangeCount || selection.isCollapsed) {
    return; // Do nothing if there's no selection
  }

  // --- Get the start and end points of the selection ---
  const anchorNode = selection.anchorNode; // Where the user first clicked
  const focusNode = selection.focusNode;   // Where the user released the click

  const startElement = anchorNode.nodeType === 3 ? anchorNode.parentNode : anchorNode;
  const endElement = focusNode.nodeType === 3 ? focusNode.parentNode : focusNode;

  // --- Determine the type of the start and end elements ---
  const startedOnCharacter = startElement.closest('.character');
  const endedOnCharacter = endElement.closest('.character');

  const startedOnPinyin = startElement.closest('.pinyin');
  const endedOnPinyin = endElement.closest('.pinyin');

  // --- CASE 1: Selection starts AND ends within the Hanzi line ---
  if (startedOnCharacter && endedOnCharacter) {
    event.preventDefault(); // Take control
    
    const range = selection.getRangeAt(0);
    const selectedContent = range.cloneContents();
    const characterNodes = selectedContent.querySelectorAll('.character');
    let cleanedText;
    if (characterNodes.length > 0){
      cleanedText = Array.from(characterNodes)
      .map(node => node.textContent)
      .join(''); // Join without spaces
      }else{
         cleanedText = range.toString();
      }
    event.clipboardData.setData('text/plain', cleanedText);
    return;
  }

  // --- CASE 2: Selection starts AND ends within the Pinyin line ---
  if (startedOnPinyin && endedOnPinyin) {
    event.preventDefault(); // Take control

    const range = selection.getRangeAt(0);
    const selectedContent = range.cloneContents();
    const pinyinNodes = selectedContent.querySelectorAll('.pinyin');
    
    const cleanedText = Array.from(pinyinNodes)
      .map(node => node.textContent.trim())
      .join(' '); // Join with spaces

    event.clipboardData.setData('text/plain', cleanedText);
    return;
  }

  // --- CASE 3 (ALL OTHERS): Crossing lines, or starting/ending outside ---
  // We do nothing and do not call event.preventDefault().
  // The browser will perform its default copy action.
};

  const parse_head = (lemmasHead) => {
    let parsedHead = [];
    try {
      parsedHead = JSON.parse(lemmasHead);
    } catch (error) {
      console.error("Error parsing lemmasHead:", error);
      return <div>Invalid lemmashead format.</div>;
    }

    if (!Array.isArray(parsedHead)) {
      return <div>No lemma lemmashead available.</div>;
    }
    // Requirement 3: Initialize a counter for consecutive line numbers.
    let visibleLineCounter = 0;

    return parsedHead.map(({ chars }, index) => {
      // First, filter the characters for the current line to see what will be visible.
      const visibleChars = chars ? chars.filter(charObj => charObj.type !== 'pinyin') : [];

      // Requirement 1: If there are no visible characters, render nothing for this line.
      if (visibleChars.length === 0) {
        return null;
      }

      // If we get here, the line will be displayed, so we increment our counter.
      visibleLineCounter++;

      // Now, render the line with the correct structure and number.
      return (
        // The key is still the original index to ensure React tracks the original items correctly.
        <div key={index} className="mb-2 lemma-container">
          
          {/* The main container is now the flex row */}
          <div className="lemma-line" onCopy={handleCopy}>

            {/* Requirement 2: Line number is now INSIDE the flex container */}
            <div className="line-number">
              {/* Use the counter for the line number, not the original data */}
              <strong>{visibleLineCounter}:</strong>
            </div>
            
            {/* Map over the already-filtered characters */}
            {visibleChars.map((charObj, charIndex) => (
                <div key={charIndex} className="char-pinyin-pair">
                  {showpinyin === 1  && (
                  <span className="pinyin">
                    {charObj.pinyin || '\u00A0'}
                  </span>
                )}
                  <span className="character">
                    {charObj.char}
                  </span>
                </div>
            ))}
          </div>
        </div>
      );
    });   



  };

  return (
    <div className="spStoreAddress">
      <BookAudioPlayer aidurl={parsed_paracont.aid} aidtext={aidtext} />
       {parse_head(lemmashead)}
    </div>
  );
};

export default CmnBookDisplay;
